"use client"

import { createContext, FC, ReactNode, useContext, useLayoutEffect } from "react"
import { storeRef } from "../providers/StoreProvider"
import { blogActions } from "@/lib/redux/features/blog/reduce"
import { BlogTravel } from "@/lib/redux/features/blog/type"

type BlogDetailContainerProps = {
  children?: ReactNode,
  blog?: BlogTravel,
  params?: any
}

const BlogDetailContext = createContext<BlogTravel | undefined>(undefined)

export const useBlogDetail = () => {
  const fromContext = useContext(BlogDetailContext)
  return fromContext
}

const BlogDetailContainer: FC<BlogDetailContainerProps> = ({ children, blog }) => {
  // Sync Redux after paint — avoid dispatch-during-render.
  // Children can also read `blog` from context for SSR-safe first paint.
  useLayoutEffect(() => {
    if (!blog) return
    storeRef.current?.dispatch(blogActions.setBlogDetailData(blog))
  }, [blog])

  return (
    <BlogDetailContext.Provider value={blog}>
      {children}
    </BlogDetailContext.Provider>
  )
}

export default BlogDetailContainer
